import type { ChangeFormField } from '../../types/changes';

/** Espelha mensagens de `form_schema.py` quando a API não envia `delete_block_reason`. */
const NATIVE_DELETE_FALLBACK: Record<string, string> = {
  title: 'O título identifica a mudança em listagens, e-mails e aprovações.',
  change_type: 'O tipo define políticas de subtarefas, Go Live e trilhas de aprovação.',
  change_owner_id: 'O dono da mudança é obrigatório no fluxo.',
  requester_id: 'O solicitante é obrigatório no fluxo.',
  category_id: 'A categoria é obrigatória no fluxo.',
  requester_area_id: 'A área solicitante é obrigatória no fluxo.',
  requester_manager_group_id:
    'A escolha do gerente imediato (1º passo de Transporte) é obrigatória quando visível.',
  go_live_window: 'A janela de Go Live é obrigatória no fluxo.',
  sap_classification: 'SAP ou Não SAP direciona o redisparo de Infra (Hosting/Nuvem).',
  description:
    'A descrição é obrigatória; para não mostrar no formulário, use ocultar ou condicional.',
  impacted_users:
    'Usuários impactados é obrigatório; para não mostrar, use ocultar ou condicional.',
  rollback_plan:
    'Plano de rollback é obrigatório; para não mostrar, use ocultar ou condicional.',
  project: 'Projeto é obrigatório; para não mostrar, use ocultar ou condicional.',
};

/** Nativos que o admin pode remover do formulário (ex.: slot opcional «Tem request?»). */
export const NATIVE_KEYS_WITH_DELETE_IN_BUILDER: ReadonlySet<string> = new Set(['sap_has_request']);

export function changeFormFieldDeleteBlockReason(field: ChangeFormField): string | null {
  if (field.delete_block_reason) {
    return field.delete_block_reason;
  }
  if (field.kind === 'extra') {
    return null;
  }
  const key = field.native_key || '';
  return NATIVE_DELETE_FALLBACK[key] ?? null;
}

/** Exibe o botão Excluir no cadastro do formulário. */
export function changeFormFieldShowsDeleteButton(field: ChangeFormField): boolean {
  if (field.kind === 'extra') {
    return true;
  }
  if (field.kind === 'native' && field.native_key) {
    return NATIVE_KEYS_WITH_DELETE_IN_BUILDER.has(field.native_key);
  }
  return false;
}

export function changeFormFieldCanDelete(field: ChangeFormField): boolean {
  if (!changeFormFieldShowsDeleteButton(field)) {
    return false;
  }
  if (field.can_delete === false) {
    return false;
  }
  if (field.can_delete === true) {
    return true;
  }
  return changeFormFieldDeleteBlockReason(field) === null;
}
